/*! chq-finder-inline v2 — 2026-10-05 CDN self-src
 *  Fixes v1: removed module self-attach (was double-binding clicks with the
 *  loader stub → double-toggle = "can't close" + duplicate render states).
 *  The loader stub is the ONLY click owner; this module only exposes
 *  window.chqFinderInline.open(card). Adds × close button + Escape to close.
 *  Single-panel guard adopts any existing panel node instead of rebuilding.
 */
(function () {
  'use strict';
  if (window.chqFinderInline && window.chqFinderInline.v >= 2.3) return;

  var DATA_URL = (function () {
    try {
      var s = document.currentScript || document.querySelector('script[src*="chq-finder-inline"]');
      if (s && s.src) {
        return s.src.replace(/chq-finder-inline[^?]*/, 'chq-core-caster-finder-v3.json').split('?')[0];
      }
    } catch (e) {}
    return '/cdn/shop/t/62/assets/chq-core-caster-finder-v3.json';
  })();
  var dataUrl = DATA_URL;
  var TOOL_URL = '/pages/caster-finder';

  var capacityRanges = [
    { label: 'Up to 300 lbs', min: 0, max: 300 },
    { label: '301–750 lbs', min: 301, max: 750 },
    { label: '751–1,500 lbs', min: 751, max: 1500 },
    { label: '1,501–3,000 lbs', min: 1501, max: 3000 },
    { label: '3,000+ lbs', min: 3001, max: 999999 }
  ];
  var mountOrder = ['Plate', 'Threaded Stem', 'Grip Ring Stem', 'Expanding Rubber Stem'];

  var products = null;
  var loading = null;
  var panel = null;
  var card = null;
  var sel = { mount: '', diam: '', cap: '' };

  function norm(v) { return String(v || '').replace(/ /g, ' ').trim(); }
  function parseCap(v) { var n = parseInt(norm(v).replace(/[^0-9]/g, ''), 10); return isNaN(n) ? null : n; }
  function inRange(val, label) {
    if (!label) return true;
    var r = null;
    for (var i = 0; i < capacityRanges.length; i++) if (capacityRanges[i].label === label) r = capacityRanges[i];
    var n = parseCap(val);
    if (!r || n === null) return false;
    return n >= r.min && n <= r.max;
  }
  function filtered(mount, diam, capRange) {
    var r = products || [];
    if (mount) r = r.filter(function (p) { return p.mount_style === mount; });
    if (diam) r = r.filter(function (p) { return p.wheel_diameter === diam; });
    if (capRange) r = r.filter(function (p) { return inRange(p.capacity, capRange); });
    return r;
  }
  function uniqueSorted(rows, field) {
    var s = {};
    rows.forEach(function (r) { var v = norm(r[field]); if (v) s[v] = 1; });
    return Object.keys(s).sort(function (a, b) {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });
  }
  function exactCaps(rangeLabel, rows) {
    var s = {};
    rows.forEach(function (r) { if (inRange(r.capacity, rangeLabel)) s[norm(r.capacity)] = 1; });
    return Object.keys(s).sort(function (a, b) { return (parseCap(a) || 0) - (parseCap(b) || 0); });
  }
  function countsBy(rows, field) {
    var m = {};
    rows.forEach(function (r) { var v = norm(r[field]); if (v) m[v] = (m[v] || 0) + (r.n || 1); });
    return m;
  }
  function sumN(rows) { var t = 0; rows.forEach(function (r) { t += (r.n || 1); }); return t; }

  function emitFunnel(stepName, value) {
    try {
      (card || document).dispatchEvent(new CustomEvent('chq:finder-step', {
        bubbles: true,
        detail: { step: stepName, value: value, finder: 'collection-inline-finder' }
      }));
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({ event: 'caster_finder_step', finder_step: stepName, finder_value: value, finder_location: 'collection-inline' });
      }
    } catch (e) {}
  }

  function buildApplyUrl() {
    var p = new URLSearchParams();
    if (sel.mount) p.append('filter.p.m.custom.mount_style', sel.mount);
    if (sel.diam) p.append('filter.p.m.custom.diameter', sel.diam);
    if (sel.cap) {
      exactCaps(sel.cap, filtered(sel.mount, sel.diam, '')).forEach(function (c) {
        p.append('filter.p.m.custom.capacity', c);
      });
    }
    var q = p.toString();
    return q ? location.pathname + '?' + q + '#products' : location.pathname + '#products';
  }

  function option(value, label, disabled) {
    var o = document.createElement('option');
    o.value = value; o.textContent = label;
    if (disabled) o.disabled = true;
    return o;
  }
  function fillSelect(node, values, countsMap, placeholder, current) {
    node.innerHTML = '';
    node.appendChild(option('', placeholder, false));
    values.forEach(function (v) {
      var c = countsMap ? countsMap[v] : null;
      node.appendChild(option(v, c != null ? v + ' (' + c + ')' : v, c === 0));
    });
    node.value = current && values.indexOf(current) > -1 ? current : '';
  }

  function render() {
    if (!products) { // pre-hydration: static mounts, no counts
      fillSelect(panel.q.mount, mountOrder.slice(), null, 'Choose mount type', sel.mount);
      fillSelect(panel.q.diam, [], null, 'Pick mount first', '');
      panel.q.diam.disabled = true;
      fillSelect(panel.q.cap, [], null, 'Pick diameter first', '');
      panel.q.cap.disabled = true;
      panel.count.textContent = 'Answer 3 quick questions to narrow this collection to your exact caster';
      panel.apply.classList.remove('is-ready');
      panel.apply.setAttribute('aria-disabled', 'true');
      return;
    }
    var mounts = uniqueSorted(products, 'mount_style').sort(function (a, b) {
      var ia = mountOrder.indexOf(a), ib = mountOrder.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    fillSelect(panel.q.mount, mounts, countsBy(products, 'mount_style'), 'Choose mount type', sel.mount);

    var afterMount = filtered(sel.mount, '', '');
    fillSelect(panel.q.diam, uniqueSorted(afterMount, 'wheel_diameter'), countsBy(afterMount, 'wheel_diameter'), sel.mount ? 'Choose wheel diameter' : 'Pick mount first', sel.diam);
    panel.q.diam.disabled = !sel.mount;

    var afterDiam = filtered(sel.mount, sel.diam, '');
    var capCounts = {};
    capacityRanges.forEach(function (r) {
      capCounts[r.label] = sumN(afterDiam.filter(function (p) { return inRange(p.capacity, r.label); }));
    });
    fillSelect(panel.q.cap, capacityRanges.map(function (r) { return r.label; }), capCounts, sel.diam ? 'Choose load capacity' : 'Pick diameter first', sel.cap);
    panel.q.cap.disabled = !sel.diam;

    var matches = sumN(filtered(sel.mount, sel.diam, sel.cap));
    var any = !!(sel.mount || sel.diam || sel.cap);
    panel.count.classList.remove('is-empty');
    if (!any) {
      panel.count.textContent = sumN(products).toLocaleString() + ' casters in this finder — pick a mount type to start';
    } else if (matches === 0) {
      panel.count.innerHTML = '<strong>No exact matches</strong> — adjust diameter or capacity';
      panel.count.classList.add('is-empty');
    } else {
      panel.count.innerHTML = '<strong>' + matches.toLocaleString() + '</strong> matching caster' + (matches === 1 ? '' : 's') + ' in this collection';
    }

    var ready = sel.mount && sel.diam && sel.cap && matches > 0;
    panel.apply.classList.toggle('is-ready', !!ready);
    panel.apply.setAttribute('aria-disabled', ready ? 'false' : 'true');
    panel.apply.href = buildApplyUrl();
  }

  function isOpen() { return !!(panel && panel.el.classList.contains('is-open')); }

  function setOpen(open) {
    if (!panel) return;
    panel.el.classList.toggle('is-open', open);
    if (card) {
      card.classList.toggle('is-open', open);
      card.setAttribute('aria-expanded', open ? 'true' : 'false');
      var em = card.querySelector('em');
      if (em) {
        if (open) { if (!em.dataset.label) em.dataset.label = em.textContent; em.textContent = 'Close finder ▴'; }
        else if (em.dataset.label) { em.textContent = em.dataset.label; }
      }
    }
  }

  function onKey(e) { if (e.key === 'Escape' && isOpen()) setOpen(false); }

  function buildPanel(slot) {
    // adopt an existing panel node if one is already in the DOM (never duplicate)
    var existing = document.getElementById('chq-fi-panel');
    if (existing) existing.parentNode.removeChild(existing);

    var div = document.createElement('div');
    div.className = 'chq-fi-panel' + (slot ? ' chq-fi-panel--band is-open' : '');
    div.id = 'chq-fi-panel';
    div.setAttribute('role', 'group');
    div.setAttribute('aria-label', 'Caster Finder');
    div.innerHTML =
      (slot ? '' : '<button type="button" class="chq-fi-close" data-fi-close aria-label="Close finder">×</button>') +
      '<div class="chq-fi-row">' +
        '<label class="chq-fi-col"><span class="chq-fi-step"><i>1</i>Mount type</span><select data-fi-mount aria-label="Mount type"></select></label>' +
        '<label class="chq-fi-col"><span class="chq-fi-step"><i>2</i>Wheel diameter</span><select data-fi-diam aria-label="Wheel diameter"></select></label>' +
        '<label class="chq-fi-col"><span class="chq-fi-step"><i>3</i>Load capacity</span><select data-fi-cap aria-label="Load capacity"></select></label>' +
        '<a class="chq-fi-apply" data-fi-apply href="#products" aria-disabled="true">Show my matches →</a>' +
      '</div>' +
      '<div class="chq-fi-foot"><span class="chq-fi-count" data-fi-count aria-live="polite"></span>' +
      '<a class="chq-fi-tool" href="' + TOOL_URL + '">Open the full Caster Finder tool</a></div>';
    if (slot) { slot.appendChild(div); } else { card.insertAdjacentElement('afterend', div); }

    panel = {
      el: div,
      q: {
        mount: div.querySelector('[data-fi-mount]'),
        diam: div.querySelector('[data-fi-diam]'),
        cap: div.querySelector('[data-fi-cap]')
      },
      count: div.querySelector('[data-fi-count]'),
      apply: div.querySelector('[data-fi-apply]')
    };

    panel.q.mount.addEventListener('change', function () {
      sel.mount = norm(this.value); sel.diam = ''; sel.cap = '';
      emitFunnel('mount', sel.mount);
      if (!products) {
        panel.count.textContent = 'Loading live catalog…';
        loadData().then(function () { render(); }).catch(function () {
          panel.count.innerHTML = 'Catalog unavailable — <a href="' + TOOL_URL + '">open the full finder tool</a>';
        });
        return;
      }
      render();
    });
    panel.q.diam.addEventListener('change', function () {
      sel.diam = norm(this.value); sel.cap = '';
      emitFunnel('diameter', sel.diam); render();
    });
    panel.q.cap.addEventListener('change', function () {
      sel.cap = norm(this.value);
      emitFunnel('capacity', sel.cap); render();
    });
    panel.apply.addEventListener('click', function (e) {
      if (this.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      emitFunnel('show_matches', { mount: sel.mount, diameter: sel.diam, capacity: sel.cap });
    });
    var cb = div.querySelector('[data-fi-close]');
    if (cb) { cb.addEventListener('click', function () { setOpen(false); }); document.addEventListener('keydown', onKey); }
  }

  function loadData() {
    if (products) return Promise.resolve(products);
    if (loading) return loading;
    var bust = (dataUrl.indexOf('?') > -1 ? '&' : '?') + 'd=' + new Date().toISOString().slice(0, 10).replace(/-/g, '');
    loading = fetch(dataUrl + bust, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (raw) {
        products = (Array.isArray(raw) ? raw : []).map(function (i) {
          if (i && i.n != null) {
            return { mount_style: norm(i.m), wheel_diameter: norm(i.d), capacity: norm(i.c), n: parseInt(i.n, 10) || 1 };
          }
          return { mount_style: norm(i.mount_style), wheel_diameter: norm(i.wheel_diameter), capacity: norm(i.capacity), n: 1 };
        }).filter(function (i) { return i.mount_style && i.wheel_diameter && i.capacity; });
        return products;
      })
      .catch(function (e) { loading = null; throw e; });
    return loading;
  }

  // Band mode: auto-render expanded into [data-chq-finder-band] .chq-fb-slot,
  // dataset hydrates on first mount selection (or first pointerenter).
  function initBand() {
    var band = document.querySelector('[data-chq-finder-band]');
    if (!band || band.__chqFB) return;
    band.__chqFB = 1;
    var slot = band.querySelector('.chq-fb-slot') || band;
    dataUrl = band.getAttribute('data-json-url') || DATA_URL;
    buildPanel(slot); render();
    band.addEventListener('pointerenter', function () { if (!products && !loading) loadData().then(function(){ if (panel) render(); }).catch(function(){}); }, { once: true });
    emitFunnel('band_visible', location.pathname);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initBand); } else { initBand(); }

  // Public API. The legacy loader stub owns card clicks; band mode self-initializes.
  window.chqFinderInline = {
    v: 2.3,
    open: function (el) {
      if (el) {
        card = el;
        card.setAttribute('aria-controls', 'chq-fi-panel');
      }
      if (panel) { setOpen(!isOpen()); return; }
      if (card) card.classList.add('is-loading');
      loadData().then(function () {
        if (card) card.classList.remove('is-loading');
        buildPanel(); render(); setOpen(true);
        emitFunnel('open', location.pathname);
      }).catch(function () {
        if (card) card.classList.remove('is-loading');
        window.location.href = TOOL_URL;
      });
    }
  };
})();
